//Action Types
export const SUBMIT_USOB_DELETE_VEHICLE_GROUP_ACTION_REQUESTED =
  "SUBMIT_USOB_DELETE_VEHICLE_GROUP_ACTION_REQUESTED";
export const SUBMIT_USOB_DELETE_VEHICLE_GROUP_ACTION_DISPATCHER =
  "SUBMIT_USOB_DELETE_VEHICLE_GROUP_ACTION_DISPATCHER";
export const SUBMIT_USOB_DELETE_VEHICLE_GROUP_ERROR_DISPATCHER =
  "SUBMIT_USOB_DELETE_VEHICLE_GROUP_ERROR_DISPATCHER";
export const SUBMIT_EMPTY_USOB_DELETE_VEHICLE_GROUP_STATE_ACTION =
  "SUBMIT_EMPTY_USOB_DELETE_VEHICLE_GROUP_STATE_ACTION";
export const USOB_DELETE_VEHICLE_GROUP_LOADING =
  "USOB_DELETE_VEHICLE_GROUP_LOADING";

//Action Creator
export const submitUSOBDeleteVehicleGroupAction = (data) => ({
  type: SUBMIT_USOB_DELETE_VEHICLE_GROUP_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitUSOBDeleteVehicleGroupActionDispatcher = (data) => ({
  type: SUBMIT_USOB_DELETE_VEHICLE_GROUP_ACTION_DISPATCHER,
  payload: data,
});

//Error Dispatcher
export const submitUSOBDeleteVehicleGroupErrorDispatcher = (data) => ({
  type: SUBMIT_USOB_DELETE_VEHICLE_GROUP_ERROR_DISPATCHER,
  payload: data,
});

//Loading Action
export const USOBDeleteVehicleGroupLoading = (loading) => ({
  type: USOB_DELETE_VEHICLE_GROUP_LOADING,
  payload: loading,
});

export const submitEmptyUSOBDeleteVehicleGroupStateAction = () => ({
  type: SUBMIT_EMPTY_USOB_DELETE_VEHICLE_GROUP_STATE_ACTION,
});
